import {connect} from '../../redux/utils'
import {getLoggedInUserId} from '../../loggedInUser/selectors'
import ReportEditConfigController from './ReportEditConfigController'

export default connect(
    state => ({
        loggedInUserId: getLoggedInUserId(state),
    })
)(ReportEditConfigController)


// WEBPACK FOOTER //
// ./web/js/reports/edit_config_controller/ATReportEditConfigController.js